<template>
  <div class="game">
    <div class="header">Week {{weekIndex + 1}} / 6</div>

    <div class="current-action">
      <ActionImage v-bind:action="currentAction"></ActionImage>
    </div>

    <div class="status">
      <div class="stat energy">
        <img src="@/assets/energy.svg" class="stat__icon">
        <span class="stat__label">Energy</span>
        <status-bar class="stat__bar" :points="player.energy.toFixed(0)" :target="75"></status-bar>
      </div>
      <div class="stat fun">
        <img src="@/assets/game.svg" class="stat__icon">
        <span class="stat__label">Fun</span>
        <status-bar class="stat__bar" :points="player.fun.toFixed(0)" :target="75"></status-bar>
      </div>
      <div class="stat math">
        <img src="@/assets/pi.svg" class="stat__icon">
        <span class="stat__label">Math</span>
        <status-bar class="stat__bar" :points="player.math.toFixed(0)"
                    :target="weekExam.topic === 'math' ? weekExam.needed : 0"></status-bar>
      </div>
      <div class="stat french">
        <img src="@/assets/cheese.svg" class="stat__icon">
        <span class="stat__label">French</span>
        <status-bar class="stat__bar" :points="player.french.toFixed(0)"
                    :target="weekExam.topic === 'french' ? weekExam.needed : 0"></status-bar>
      </div>
      <div class="stat sport">
        <img src="@/assets/sport.svg" class="stat__icon">
        <span class="stat__label">Sport</span>
        <status-bar class="stat__bar" :points="player.sport.toFixed(0)"
                    :target="weekExam.topic === 'sport' ? weekExam.needed : 0"></status-bar>
      </div>
    </div>

    <div class="timeline">
      <div v-if="player.gameOver" class="timeline-game-over">
        Game Over
      </div>
      <div v-else-if="weekFinished" class="timeline-week-finished">
        Congratulations
      </div>
      <div v-else>
        <ActionTimeline></ActionTimeline>
      </div>
    </div>

    <div class="available-actions">
      <div v-if="player.gameOver" class="actions-game-over">
        <div v-html="player.gameOverReason.title"></div>
        <div>
          <button class="restart-button" v-on:click="onClickRestart">Restart Game</button>
        </div>
      </div>

      <div v-else-if="weekFinished" class="actions-week-finished">
        <div>You passed the exam and finished week number {{weekIndex + 1}}</div>
        <div style="margin-top: 4vh">

          <button v-if="weekIndex >= 5" class="start-next-week-button" v-on:click="onClickOutro">Go to scout camp!
          </button>
          <button v-else class="start-next-week-button" v-on:click="startWeek">Start next week</button>
        </div>
      </div>

      <div v-else>
        <div class="actions">
          <ActionCard :action-object="getActionObject('mathFree')" v-bind:on-click="onClickCard"/>
          <ActionCard :action-object="getActionObject('frenchFree')" v-bind:on-click="onClickCard"/>
          <ActionCard :action-object="getActionObject('sportFree')" v-bind:on-click="onClickCard"/>
          <ActionCard :action-object="getActionObject('gamingFree')" v-bind:on-click="onClickCard"/>
          <ActionCard :action-object="getActionObject('sleepFree')" v-bind:on-click="onClickCard"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ActionImage from "./ActionImage";
import ActionCard from "./ActionCard";
import ActionTimeline from "./ActionTimeline";
import StatusBar from "./StatusBar";
import { actions } from "../GameEngine";
import sounds from "../sounds";

const SLOTS_PER_DAY = 5;
const MILLISECONDS_PER_SLOT = 1500;

export default {
  name: "HelloWorld",
  components: {
    ActionImage,
    ActionCard,
    ActionTimeline,
    StatusBar,
  },
  data() {
    return {
      currentTime: 0
    };
  },
  computed: {
    timeWeekDay: function() {
      return this.currentTime % 5;
    },
    hourAsString: function() {
      let seconds = Math.floor(this.timeWeekDay * (24 * 60 * 60) / (60 * 60)) * (60 * 60);
      let date = new Date(null);
      date.setSeconds(seconds);
      return date.toISOString().substr(11, 5);
    },
    daySlotIndex: function() {
      return Math.floor(this.currentTime * SLOTS_PER_DAY % 5);
    },
    ...mapState(["player", "currentSlotIndex", "weekRunning", "weekFinished"]),
    ...mapGetters(["currentAction", "nextAction", "weekIndex", "weekExam", "weekActions"])
  },
  mounted() {
    const self = this;

    console.log(this.weekActions);
    let lastTimestamp = 0;
    let diffTimestamp = 0;

    function stepAnimationFrame(timestamp) {
      diffTimestamp = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      let lastSlotIndex = self.daySlotIndex;

      if(self.weekRunning && !self.player.gameOver) {
        self.currentTime += diffTimestamp / MILLISECONDS_PER_SLOT / SLOTS_PER_DAY;

        if(lastSlotIndex !== self.daySlotIndex) {
          self.$store.dispatch("incrementSlot");
        }
      }
      window.requestAnimationFrame(stepAnimationFrame);
    }

    this.requestId = window.requestAnimationFrame(stepAnimationFrame);

    sounds.playBackground();
  },
  methods: {
    onClickCard: function(action) {
      const actionName = `${action}Free`;
      console.log("onClick card, ", action, actionName);
      this.$store.dispatch("setNextSlot", {
        action: `${action}Free`
      });
    },
    onClickRestart: function() {
      this.$store.dispatch("resetGame");
      this.$store.dispatch("changeGameState", { name: "IntroScreen" });
    },
    startWeek: function() {
      this.$store.commit("startWeek");
    },
    getActionObject: function(actionName) {
      return actions[actionName];
    },
    onClickOutro: function() {
      this.$store.dispatch("changeGameState", { name: "OutroScreen" });
    }
  },
  beforeDestroy() {
    if(this.requestId) {
      window.cancelAnimationFrame(this.requestId);
    }
    sounds.stopBackground();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$game-background: #341f34;

.actions {
  margin-top: 1vw;
  display: flex;
  justify-content: space-around;
}

.game {
  background: $game-background;
  color: white;
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-rows: 3vh 4fr 1fr 2fr;
  grid-template-columns: 1fr 4fr;
  grid-template-areas: "header header" "status current" "timeline timeline" "actions actions";
  grid-column-gap: 0;
  grid-row-gap: 0;

  .header {
    grid-area: header;

    text-align: center;
    font-size: 1.8vw;
    align-self: center;
  }

  .current-action {
    grid-area: current;
  }

  .timeline {
    grid-area: timeline;
  }

  .available-actions {
    grid-area: actions;
  }

  .status {
    grid-area: status;

    padding-left: 4vw;
  }

  .icon {
    width: 30px;
    height: 30px;
  }
}

.stat {
  display: grid;
  grid-template-columns: 2vh 1fr;
  grid-template-rows: 1fr 3vh;
  grid-column-gap: 2vw;
  grid-template-areas: "icon label" ". bar";
  /*align-items: center;*/
  margin-bottom: 3vh;

  &__icon {
    grid-area: icon;
    width: 3vh;
    height: 3vh;
  }

  &__label {
    grid-area: label;
    font-size: 3vh
  }

  &__bar {
    grid-area: bar;
  }
}

.timeline-game-over {
  width: 100%;
  height: 100%;
  background: #e94f4e;
  font-size: 10vh;
  text-align: center;
}

.timeline-week-finished {
  width: 100%;
  height: 100%;
  background: #12cc85;
  font-size: 10vh;
  text-align: center;
}

.actions-game-over {
  width: 100%;
  height: 100%;
  background: #e94f4e;
  font-size: 5vh;
  text-align: center;
}

.actions-week-finished {
  width: 100%;
  height: 100%;
  background: #12cc85;
  font-size: 5vh;
  text-align: center;
}

.restart-button {
  background-color: #00cb81;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}

.start-next-week-button {
  background-color: #fff4de;
  border: none;
  color: black;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
}
</style>
